import { CountryName } from 'src/types/country-name';

export const SUBVENTION_COUNTRY: CountryName[] = [
  CountryName.saudi,
  CountryName.emirates,
];
